import RoleView from "../../Navigation/RoleView";
import TeachrHome from "../../App/Home/TeachrHome";
import ClientHome from "../../App/Home/ClientHome";

/**
 * Accueil du tableau de bord commun : page principale de /tableau-de-bord.
 * Le contenu est porté par deux composants enfants dans App/Home, un pour le
 * prof (TeachrHome) et un pour le client (ClientHome), choisis selon le rôle
 * connecté.
 */
const HomePage = () => (
    <RoleView prof={<TeachrHome />} client={<ClientHome />} />
);

export default HomePage;
